module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-a5d2e537.svg";